import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  Grid,
  TableContainer,
  Table,
  TextField,
  InputLabel,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import { ReactComponent as UploadFileIcon } from "../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";

export default function NewsEdit() {
  const dispatch = useDispatch()
  const { id } = useParams(); // Get the news ID from the URL parameters
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
    register,
    watch,
  } = useForm({
    mode: "onTouched",
  });
  const allLanguages = useSelector((state) => state.language.languageList)
  const Imgwatch = watch("img");
  const imgFile = useRef();
  
  const [activeLanguagesHeader, setActiveLanguagesHeader] = useState(allLanguages);
  

  const navigate = useNavigate();
  console.log(watch("title"));

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"], // toggled buttons
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"], // superscript/subscript
    ],
  };

  // const modules = {
  //   toolbar: [
  //     ["bold", "italic", "underline"],
  //     [{ list: "ordered" }, { list: "bullet" }],
  //     ["link"],
  //   ],
  // };

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    img: null,
  });

  // const imgFile = useRef();

  // Fetch the existing news data
  useEffect(() => {
    if (id) {
      const fetchNews = async () => {
        try {
          const response = await axiosInstance.get(
            `${process.env.REACT_APP_API_URL}getNewsbyId/${id}`
          );
          const data = response.data.data;
          console.log(data);
          setValue("title", data?.title)
          setValue("description", data?.description)
          setValue("img", data?.img);
        } catch (error) {
          console.log(error);
          if(error.response.status === 401 || error.response.status === 403){
            navigate('/Admin/login')
            dispatch(removeData())
        }
        }
      };
      fetchNews();
    }
  }, [id]);

  // const handleChange = (e) => {
  //   const { name, value, files } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: files ? files[0] : value,
  //   }));
  // };

  // const handleQuillChange = (value) => {
  //   console.log(value)
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     description: value,
  //   }));
  // };

  // const handleClearImage = () => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     img: null,
  //   }));
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const form = new FormData();
  //   form.append("title", formData.title);
  //   form.append("description", formData.description);
  //   if (formData.img && typeof formData.img === "object") {
  //     form.append("img", formData.img);
  //   }

  //   console.log(form, 'form')
  //   try {
  //     if(formData.title !== '' && formData.description !== '' && formData.img !== null){

  //     const response = await axios.put(
  //       `${process.env.REACT_APP_API_URL}editNews/${id}`,
  //       form,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     navigate("/Admin/NewsList");
  //     console.log(response);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // console.log(errors);

  const onSubmit = async (data) => {

    const formData = new FormData();

    formData.append("title", JSON.stringify(data?.title))
    formData.append("description", JSON.stringify(data?.description))
    formData.append("img", data?.img);
    if (id) {
      try {
        const response = await axiosInstance.put(
          `${process.env.REACT_APP_API_URL}editNews/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        navigate("/Admin/NewsList");
        console.log(response);
      } catch (error) {
        console.log(error);
        if(error.response.status === 401 || error.response.status === 403){
          navigate('/Admin/login')
          dispatch(removeData())
      }
      }
    } else {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}addnews`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        navigate("/Admin/NewsList");
        console.log(response);
      } catch (error) {
        console.log(error);
        if(error.response.status === 401 || error.response.status === 403){
          navigate('/Admin/login')
          dispatch(removeData())
      }
      }
    }
  };

  const checkQuillContent = (content) => {
    console.log("content", content);
    const isEmpty = content === "<p><br></p>" || content === "";
    return !isEmpty;
  };

  return (
    // <Box sx={{ display: "flex", justifyContent: "center" }}>
    //   <Card sx={{ width: 650, border:'1px solid #E5E7EB', borderRadius:"6px"}}>
    //     <CardContent style={{ padding: 0, margin: 0 }}>
    //     <Box
    //         sx={{
    //           display: "flex",
    //           justifyContent: "flex-start",
    //           alignItems: "center",
    //           backgroundColor: "#FCFCFD",
    //           padding: 2,
    //           border:'1px solid #E5E7EB',
    //           borderRadius:'6px 6px 0px 0px'

    //         }}
    //       >
    //         <FormIcon style={{ marginRight: "10px" }} />
    //         <Typography variant="h6_1">News Edit</Typography>
    //       </Box>

    //   <form onSubmit={handleSubmit}>
    //   <Box style={{ padding: "25px 17px 17px 17px" }}>
    //         <InputLabel sx={{
    //               mb: 1,
    //               fontSize: "18px",
    //               fontWeight: 600,
    //               color: "black",
    //             }}>{formData?.title ? 'Title' : 'Title*'}</InputLabel>
    //         <TextField
    //           name="title"
    //           sx={{
    //             mt: 0,
    //             backgroundColor : 'rgb(249, 250, 251)',
    //             borderRadius: 0,
    //             "& .MuiInputBase-input": {
    //               color: formData?.title ? "black" : "red",
    //             },
    //             "& .MuiOutlinedInput-root": {
    //               "& fieldset": {
    //                 borderColor: formData?.title ? "rgba(0, 0, 0, 0.23)" : "#ff5e74",
    //               },
    //               "&:hover fieldset": {
    //                 borderColor: formData?.title ? "rgba(0, 0, 0, 0.23)" : "#ff5e74",
    //               },
    //               "&.Mui-focused fieldset": {
    //                 borderColor: formData?.title ? "rgba(0, 0, 0, 0.23)" : "#ff5e74",
    //               },
    //             },
    //           }}
    //           value={formData.title}
    //           onChange={handleChange}
    //           required
    //         />
    //         {formData?.title ? null:<Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter title</Typography> }
    //         </Box>

    //         <Box style={{ padding: "0px 17px 17px" }}>
    //         <InputLabel sx={{
    //               mb: 1,
    //               fontSize: "18px",
    //               fontWeight: 600,
    //               color: "black",
    //             }}>{formData?.description !== '<p><br></p>' ? 'Description' : 'Description*'}</InputLabel>
    //         <ReactQuill
    //           style={{ height: "180px" }}
    //           modules={modules}
    //           value={formData.description}
    //           onChange={handleQuillChange}
    //           maxLength={3000}
    //         />

    //         </Box>

    //         <Box style={{ marginTop : '2rem', marginLeft : '1rem'}}>
    //         {(formData?.description !== '<p><br></p>') ? null:<Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter description</Typography> }
    //         </Box>

    //         <Box
    //         sx={{
    //           display: "flex",
    //           justifyContent: "flex-start",
    //           alignItems: "center",
    //           backgroundColor: "#FCFCFD",
    //           padding: 2,
    //           border:'1px solid #E5E7EB',
    //           marginTop : 7
    //         }}
    //       >
    //         <FormIcon style={{ marginRight: "10px" }} />
    //         <Typography sx={{
    //               fontSize: "20px",
    //               fontWeight: 600,
    //               color: "black",
    //             }}>News Image</Typography>
    //         </Box>

    //         {formData.img ? (
    //           <Box style={{ padding: "20px 17px 17px" }}>
    //           <Stack
    //             direction="row"
    //             justifyContent="space-between"
    //             alignItems="center"
    //             padding="23px"
    //             borderRadius="8px"
    //             sx={{ border: ".5px solid #1A2461" }}
    //           >
    //             <Typography
    //               variant="h9_1"
    //               sx={{ display: "flex", alignItems: "center", gap: "10px" }}
    //             >
    //               <ImgIcon />
    //               {typeof formData.img === "object"
    //                 ? formData.img.name
    //                 : formData.img}
    //             </Typography>
    //             <ClearIcon
    //               onClick={handleClearImage}
    //               sx={{ color: "#1A2461", cursor: "pointer" }}
    //             />
    //           </Stack>
    //           </Box>
    //         ) : (
    //           <Box
    //             xs={12}
    //             onClick={() => imgFile.current.click()}
    //             sx={{
    //               border: (formData?.img == null)
    //                   ? "1px dashed red"
    //                   : "1px dashed #1A2461",
    //               height: "200px",
    //               borderRadius: "8px",
    //               backgroundColor: "#F9FBFF",
    //               margin: '20px 17px 17px'
    //             }}
    //           >
    //             <Stack
    //               direction="column"
    //               alignItems="center"
    //               justifyContent="center"
    //               height="100%"
    //             >
    //               <Stack
    //                 direction="row"
    //                 alignItems="center"
    //                 justifyContent="center"
    //                 sx={{
    //                   height: "100px",
    //                   width: "100px",
    //                   borderRadius: "100px",
    //                   backgroundColor: "#F2F2F2",
    //                 }}
    //               >
    //                 <UploadFileIcon fill="#1A2461" />
    //               </Stack>
    //               <Stack mt={2} direction="row" alignItems="center" gap="5px">
    //                 <Typography variant="h9_1">Click to upload</Typography>
    //               </Stack>
    //               <Typography variant="h9_5">
    //                 Allowed formats - JPEG, PNG
    //               </Typography>
    //             </Stack>
    //           </Box>
    //         )}
    //         <input
    //           type="file"
    //           accept="image/*"
    //           name="img"
    //           onChange={handleChange}
    //           ref={imgFile}
    //           hidden
    //         />

    //      <Divider style={{marginTop : '35px'}}/>
    //         <Box
    //           sx={{
    //             display: "flex",
    //             justifyContent: "flex-end",
    //             padding: "0px 17px 13px",
    //           }}
    //         >
    //           <Button
    //            variant="contained"
    //            type="submit"
    //            sx={{
    //              padding: "10px 20px 10px 20px",
    //              mt: 2,
    //              width: "20%",
    //              fontSize: 20,
    //              backgroundColor: "rgb(14, 94, 132)",
    //              ":hover": { bgcolor: "rgb(14, 94, 132)" },
    //            }}>
    //             Update
    //           </Button>
    //           </Box>

    //   </form>
    //   </CardContent>
    //   </Card>
    // </Box>

    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Card
        sx={{ width: "80%", border: "1px solid #E5E7EB", borderRadius: "6px" }}
      >
        <CardContent style={{ padding: 0, margin: 0 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border: "1px solid #E5E7EB",
              borderRadius: "6px 6px 0px 0px",
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography variant="h6_1">News Edit</Typography>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)}>
            {activeLanguagesHeader.map((lang) => (
              <Box key={lang.symbol} style={{ padding: "25px 17px 17px 17px" }}>
                {/* Title */}
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.[`title.${lang.value}`]
                    ? `Title - ${lang.name}*`
                    : `Title - ${lang.name}`}
                </InputLabel>

                <Controller
                  name={`title.${lang.value}`} // Dynamically set name based on the symbol
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) =>
                   
                      <TextField
                        error={Boolean(errors?.[`title.${lang.value}`])}
                        {...field}
                        placeholder="Enter title"
                        sx={{
                          mt: 0,
                          backgroundColor: "rgb(249, 250, 251)",
                          borderRadius: 0,
                          "& .MuiInputBase-input": {
                            color: errors?.[`title.${lang.value}`]
                              ? "red"
                              : "black",
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: errors?.[`title.${lang.value}`]
                                ? "#ff5e74"
                                : "rgba(0, 0, 0, 0.23)",
                            },
                            "&:hover fieldset": {
                              borderColor: errors?.[`title.${lang.value}`]
                                ? "#ff5e74"
                                : "rgba(0, 0, 0, 0.23)",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: errors?.[`title.${lang.value}`]
                                ? "#ff5e74"
                                : "rgba(0, 0, 0, 0.23)",
                            },
                          },
                        }}
                      />
                  }
                />
                {errors?.[`title.${lang.value}`] && (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please enter title
                  </Typography>
                )}

                {/* Description */}
                {/* <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.[`description_${lang.symbol}`]
                    ? "Description*"
                    : "Description"}
                </InputLabel>
                <Controller
                  name={`description_${lang.symbol}`} // Dynamically set name for description
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) =>
                    lang.description.type === "richTextEditor" ? (
                      <ReactQuill
                        value={field.value}
                        onChange={field.onChange}
                        style={{ height: "180px", marginBottom: "1rem" }}
                        modules={modules}
                      />
                    ) : null
                  }
                />
                {errors?.[`description_${lang.symbol}`] && (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please enter description
                  </Typography>
                )} */}
              </Box>
            ))}
            <Divider sx={{ my: "30px" }} />{" "}
            {activeLanguagesHeader.map((lang) => (
              <Box style={{ padding: "0px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.[`description.${lang.value}`]
                    ? `Description - ${lang.name}*`
                    : `Description - ${lang.name}`}
                </InputLabel>
                <Controller
                  name={`description.${lang.value}`}
                  rules={{
                    validate: (value) => checkQuillContent(value),
                    required: true,
                  }}
                  control={control}
                  render={({ field }) => (
                    <ReactQuill
                      style={{ height: "180px", marginBottom: "1rem" }}
                      modules={modules}
                      maxLength={3000}
                      {...field}
                    />
                  )}
                />
                <Box style={{ marginTop: "4rem", marginLeft: "1rem" }}>
                  {errors?.[`description.${lang.value}`] ? (
                    <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                      Please enter description
                    </Typography>
                  ) : null}
                </Box>
              </Box>
            ))}
            {/* Image Upload Section */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                marginTop: 7,
              }}
            >
              <FormIcon style={{ marginRight: "10px" }} />
              <Typography
                sx={{ fontSize: "20px", fontWeight: 600, color: "black" }}
              >
                News Image
              </Typography>
            </Box>
            <Divider style={{ marginTop: "35px" }} />
            {Boolean(Imgwatch) ? (
              <Box style={{ padding: "20px 17px 17px" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  padding="23px"
                  borderRadius="8px"
                  sx={{ border: ".5px solid #1A2461" }}
                >
                  <Typography
                    variant="h9_1"
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <ImgIcon />
                    {Imgwatch instanceof File ? Imgwatch.name : Imgwatch}
                  </Typography>
                  <ClearIcon
                    onClick={() => setValue("img", null)}
                    sx={{ color: "#1A2461" }}
                  />
                </Stack>
              </Box>
            ) : (
              <Box
                xs={12}
                onClick={() => imgFile.current.click()}
                sx={{
                  border: Boolean(errors.img)
                    ? "1px dashed red"
                    : "1px dashed #1A2461",
                  height: "200px",
                  borderRadius: "8px",
                  backgroundColor: "#F9FBFF",
                  margin: "20px 17px 17px",
                }}
              >
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "100px",
                      backgroundColor: "#F2F2F2",
                    }}
                  >
                    <UploadFileIcon fill="#1A2461" />
                  </Stack>
                  <Stack mt={2} direction="row" alignItems="center" gap="5px">
                    <Typography variant="h9_1">Click to upload</Typography>
                  </Stack>
                  <Typography variant="h9_5">
                    Allowed formats - JPEG, PNG
                  </Typography>
                </Stack>
                <Box sx={{ marginTop: "0.3rem" }}>
                  {errors?.img ? (
                    <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                      Please select an Image
                    </Typography>
                  ) : null}
                </Box>
              </Box>
            )}
            <Controller
              name="img"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    field.onChange(e.target.files[0]);
                    e.target.value = null;
                  }}
                  ref={(e) => {
                    imgFile.current = e;
                  }}
                  hidden
                />
              )}
            />
            <Divider style={{ marginTop: "35px" }} />{" "}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0px 17px 13px",
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{
                  padding: "10px 20px 10px 20px",
                  mt: 2,
                  width: "20%",
                  fontSize: 20,
                  backgroundColor: "rgb(14, 94, 132)",
                  ":hover": { bgcolor: "rgb(14, 94, 132)" },
                }}
              >
                {id ? "Update" : "Add"}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
